import Card from '../ui/Card';
import type { ReactNode } from 'react';
import { CHART } from '../../config/chartTheme';

/**
 * Kennzahl-Kachel. Die Zahl ist hier das Diagramm — ein Balken für einen Wert
 * wäre Dekoration.
 *
 * Bewusst proportionale Ziffern (kein `tabular-nums`): bei Displaygrößen lässt
 * gleiche Zifferbreite Zahlen wie „121" auseinandergezogen wirken. Tabellarische
 * Ziffern gehören in die Tabellenansicht, wo Spalten fluchten müssen.
 */
export default function StatTile({
  label,
  value,
  sub,
  accent,
}: {
  label: string;
  value: string;
  sub?: ReactNode;
  accent?: string;
}) {
  return (
    <Card className="p-4">
      <div className="text-xs font-medium text-gray-500">{label}</div>
      <div className="text-2xl font-bold mt-1" style={{ color: accent ?? CHART.foreground }}>
        {value}
      </div>
      {sub && <div className="text-xs text-gray-400 mt-0.5">{sub}</div>}
    </Card>
  );
}
